import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import React from 'react';
import S from './ContactDetails.styles';
const ContactDetails = ({ address, links, linksTitle, openingTimes, addressTitle, openingTimesTitle, }) => {
    return (React.createElement(S.Container, null,
        links && (React.createElement(S.Section, null,
            linksTitle && React.createElement(S.Title, null, linksTitle),
            React.createElement(S.List, null, links.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { href: item.url, target: item.target },
                    React.createElement(S.Icon, { as: SvgChevronRight }),
                    React.createElement(S.Text, null, item.text)),
                item.supportingText && React.createElement(S.SupportingText, null, item.supportingText))))))),
        address && (React.createElement(S.Section, null,
            React.createElement(S.Title, null, addressTitle),
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: address } }))),
        openingTimes && (React.createElement(S.Section, null,
            React.createElement(S.Title, null, openingTimesTitle),
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: openingTimes } })))));
};
export default ContactDetails;
